import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-418304f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "ling-list-print" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "executable" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "*", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "dir" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/", -1))
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "link" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " -> ", -1))
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 3,
  class: "plain-file"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(`total ${this.files.length}`), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.files, (file, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "file",
        key: index
      }, [
        (file.type === _ctx.EFileType.EXECUTABLE)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createTextVNode(_toDisplayString(`-rwxr-xr-x 1 ruichen ruichen ${file.size.padStart(
            this.sizeLength,
            "\xa0"
          )} ${file.date} `) + " ", 1),
              _createElementVNode("span", _hoisted_3, _toDisplayString(file.name), 1),
              _hoisted_4
            ]))
          : _createCommentVNode("", true),
        (file.type === _ctx.EFileType.DIR)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
              _createTextVNode(_toDisplayString(`drwxr-xr-x 1 ruichen ruichen ${file.size.padStart(
            this.sizeLength,
            "\xa0"
          )} ${file.date}`) + " ", 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(file.name), 1),
              _hoisted_7
            ]))
          : _createCommentVNode("", true),
        (file.type === _ctx.EFileType.LINK)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
              _createTextVNode(_toDisplayString(`lrwxrwxrwx 1 ruichen ruichen ${file.size.padStart(
            this.sizeLength,
            "\xa0"
          )} ${file.date}`) + " ", 1),
              _createElementVNode("span", _hoisted_9, _toDisplayString(file.name), 1),
              _hoisted_10,
              _createElementVNode("a", {
                class: "link-href",
                href: file.value,
                target: "_blank",
                rel: "noopener noreferrer"
              }, _toDisplayString(file.value), 9, _hoisted_11)
            ]))
          : _createCommentVNode("", true),
        (file.type === _ctx.EFileType.FILE || file.type === _ctx.EFileType.IMAGE)
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(`-rw-r--r-- 1 ruichen ruichen ${file.size.padStart(
            this.sizeLength,
            "\xa0"
          )} ${file.date} ${file.name}`), 1))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}